<template lang="pug">
  IntersectionObserver.base-auto-loading(
    ref="container"
    @appear="emitLoadNewItems"
    :options="options"
  )
    .base-auto-loading__content(
      v-show="fetching"
    )
      slot(
        name="placeholder"
      )
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import IntersectionObserver from '@/components/lh-ui/IntersectionObserver/IntersectionObserver.vue';

  export default defineNuxtComponent({
    name: 'BaseAutoLoading',

    components: {
      IntersectionObserver,
    },

    props: {
      fetching: {
        type: Boolean as PropType<boolean>,
        required: true,
      },
      options: {
        type: Object as PropType<IntersectionObserverInit>,
        default: (): IntersectionObserverInit => {
          if (import.meta.client) {
            return {
              rootMargin: `${window.innerHeight}px 0px ${window.innerHeight * 1.5}px 0px`,
            };
          } else {
            return {
              rootMargin: '0px 0px 0px 0px',
            };
          }
        },
      },
    },

    watch: {
      fetching(newVal) {
        if (!newVal) {
          setTimeout(() => {
            try {
              // Если после окончания загрузки компонент отображается на экране или выше экрана генерирует событие
              const container = (this.$refs.container as Vue).$el as HTMLElement;
              if (this.needLoadNewItems(container)) {
                this.emitLoadNewItems();
              }
            } catch {}
          }, 500);
        }
      },
    },

    methods: {
      emitLoadNewItems(): void {
        if (this.fetching) {
          return;
        }
        this.$emit('load-new-items');
      },
      needLoadNewItems(el: HTMLElement): boolean {
        const rect = el.getBoundingClientRect();

        return (rect.top > 0 && rect.top <= window.innerHeight * 1.5) || rect.top <= 0;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .base-auto-loading {
    min-width: 1px;
    min-height: 1px;
  }
</style>
